export { default as AnimatedBottomToTop } from './BottomToTop';
export { default as AnimatedSmooth } from './Smooth';
